/* Mama's Daily sale campaign.
   - Counts down to the one real end date set in Theme settings > Sale campaign (same for every visitor, never resets).
   - When it reaches zero, hides everything marked [data-mdh-sale-live] and shows [data-mdh-sale-ended].
   - Fills in the estimated delivery dates. */
(function () {
  if (window.__mdhSale) return;
  window.__mdhSale = true;

  function pad(n) { return String(n).padStart(2, '0'); }

  function tick() {
    var now = Date.now();
    document.querySelectorAll('[data-mdh-sale-end]').forEach(function (root) {
      var end = Number(root.getAttribute('data-mdh-sale-end')) * 1000;
      var diff = Math.max(0, end - now);
      var parts = {
        d: pad(Math.floor(diff / 864e5)),
        h: pad(Math.floor(diff / 36e5) % 24),
        m: pad(Math.floor(diff / 6e4) % 60),
        s: pad(Math.floor(diff / 1e3) % 60)
      };
      root.querySelectorAll('[data-cd]').forEach(function (el) {
        var k = el.getAttribute('data-cd');
        if (k === 'inline') el.textContent = parts.d + 'd ' + parts.h + ':' + parts.m + ':' + parts.s;
        else if (parts[k] !== undefined) el.textContent = parts[k];
      });
      if (diff === 0) {
        document.documentElement.classList.add('mdh-sale-over');
        root.querySelectorAll('[data-mdh-sale-live]').forEach(function (el) { el.hidden = true; });
        root.querySelectorAll('[data-mdh-sale-ended]').forEach(function (el) { el.hidden = false; });
        if (root.hasAttribute('data-mdh-sale-live')) root.hidden = true;
      }
    });
  }

  function etas() {
    document.querySelectorAll('[data-mdh-eta]').forEach(function (el) {
      var min = Number(el.getAttribute('data-min')) || 5;
      var max = Math.max(min, Number(el.getAttribute('data-max')) || min);
      var fmt = function (n) {
        var d = new Date(); d.setDate(d.getDate() + n);
        return d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' });
      };
      var out = el.querySelector('[data-mdh-eta-dates]');
      if (out) out.textContent = min === max ? fmt(min) : fmt(min) + ' – ' + fmt(max);
      el.hidden = false;
    });
  }

  function start() { tick(); etas(); setInterval(tick, 1000); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', function () { tick(); etas(); });
})();
